/* Vanatics Startseite · Produkt-Slider · v1.0
   Wechsel per Pfeil, Thumbnail, Wischen, Pfeiltasten und automatisch.
   Pausiert bei Maus darüber, Fokus im Slider und verborgenem Tab.
   Kein automatischer Wechsel bei «Bewegung reduzieren». */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function Slider(root) {
    this.root = root;
    this.slides = root.querySelectorAll('[data-slide]');
    this.thumbs = root.querySelectorAll('[data-thumb]');
    this.strip = root.querySelector('.vxh-ps__thumbs');
    this.count = this.slides.length;
    this.index = 0;
    this.seconds = parseInt(root.getAttribute('data-interval'), 10) || 6;
    this.auto = root.getAttribute('data-autoplay') === 'true' && !reduce && this.count > 1;
    this.timer = null;
    this.paused = false;
    root.style.setProperty('--vxh-interval', this.seconds + 's');
    if (this.count < 2) return;
    this.bind();
    this.start();
  }

  Slider.prototype.go = function (i, fromUser) {
    var n = this.count;
    i = ((i % n) + n) % n;
    for (var k = 0; k < n; k++) {
      var on = k === i;
      this.slides[k].classList.toggle('is-active', on);
      this.slides[k].setAttribute('aria-hidden', on ? 'false' : 'true');
      if (this.thumbs[k]) {
        this.thumbs[k].classList.toggle('is-active', on);
        this.thumbs[k].setAttribute('aria-selected', on ? 'true' : 'false');
        this.thumbs[k].tabIndex = on ? 0 : -1;
      }
    }
    this.index = i;
    this.scrollThumb();
    this.restartProgress();
    if (fromUser) this.start();
  };

  Slider.prototype.scrollThumb = function () {
    var t = this.thumbs[this.index];
    if (!t || !this.strip) return;
    var left = t.offsetLeft - this.strip.offsetLeft;
    var right = left + t.offsetWidth;
    if (left < this.strip.scrollLeft || right > this.strip.scrollLeft + this.strip.clientWidth) {
      this.strip.scrollTo({ left: Math.max(0, left - 12), behavior: reduce ? 'auto' : 'smooth' });
    }
  };

  Slider.prototype.restartProgress = function () {
    var bars = this.root.querySelectorAll('.vxh-ps__prog');
    for (var k = 0; k < bars.length; k++) bars[k].classList.remove('is-running');
    if (!this.auto) return;
    var bar = this.thumbs[this.index] && this.thumbs[this.index].querySelector('.vxh-ps__prog');
    if (bar) { void bar.offsetWidth; bar.classList.add('is-running'); }
  };

  Slider.prototype.start = function () {
    var self = this;
    clearInterval(this.timer);
    if (!this.auto) return;
    this.restartProgress();
    this.timer = setInterval(function () {
      if (!self.paused && !document.hidden) self.go(self.index + 1, false);
    }, this.seconds * 1000);
  };

  Slider.prototype.pause = function (on) {
    this.paused = on;
    this.root.classList.toggle('is-paused', on);
    if (!on) this.start();
  };

  Slider.prototype.bind = function () {
    var self = this, root = this.root;
    var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { self.go(self.index - 1, true); });
    if (next) next.addEventListener('click', function () { self.go(self.index + 1, true); });
    Array.prototype.forEach.call(this.thumbs, function (t) {
      t.addEventListener('click', function () { self.go(parseInt(t.getAttribute('data-thumb'), 10), true); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); self.go(self.index + 1, true); self.thumbs[self.index].focus(); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(self.index - 1, true); self.thumbs[self.index].focus(); }
      });
    });
    root.addEventListener('mouseenter', function () { self.pause(true); });
    root.addEventListener('mouseleave', function () { self.pause(false); });
    root.addEventListener('focusin', function () { self.pause(true); });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) self.pause(false); });

    var stage = root.querySelector('.vxh-ps__stage'), x0 = null, y0 = null;
    if (stage) {
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) self.go(self.index + (dx < 0 ? 1 : -1), true);
        x0 = null;
      }, { passive: true });
    }
    this.go(0, false);
  };

  function init(scope) {
    var list = (scope || document).querySelectorAll('[data-vxh-slider]');
    Array.prototype.forEach.call(list, function (el) {
      if (el.__vxh) return;
      el.__vxh = new Slider(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* Theme-Editor: neu laden und gewählten Block anzeigen */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest && e.target.closest('[data-slide]');
    if (!slide) return;
    var root = slide.closest('[data-vxh-slider]');
    if (root && root.__vxh && root.__vxh.go) { root.__vxh.go(parseInt(slide.getAttribute('data-slide'), 10), false); root.__vxh.pause(true); }
  });
})();
